import React, { Fragment } from "react";
import { MyPageHead } from "../myPage/common";
import "./camfit_css.css";

const PrivacyPolicy = () => {
  return (
    <Fragment>
      <MyPageHead title="개인정보 처리방침" />
      <div className="wmde-markdown wmde-markdown-color">
        <h3 id="플로웨이-개인정보-처리방침">
          <a
            className="anchor"
            aria-hidden="true"
            tabIndex="-1"
            href="#플로웨이-개인정보-처리방침"
          >
            <svg
              className="octicon octicon-link"
              viewBox="0 0 16 16"
              version="1.1"
              width="16"
              height="16"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M7.775 3.275a.75.75 0 001.06 1.06l1.25-1.25a2 2 0 112.83 2.83l-2.5 2.5a2 2 0 01-2.83 0 .75.75 0 00-1.06 1.06 3.5 3.5 0 004.95 0l2.5-2.5a3.5 3.5 0 00-4.95-4.95l-1.25 1.25zm-4.69 9.64a2 2 0 010-2.83l2.5-2.5a2 2 0 012.83 0 .75.75 0 001.06-1.06 3.5 3.5 0 00-4.95 0l-2.5 2.5a3.5 3.5 0 004.95 4.95l1.25-1.25a.75.75 0 00-1.06-1.06l-1.25 1.25a2 2 0 01-2.83 0z"
              ></path>
            </svg>
          </a>
          플로웨이 개인정보 처리방침
        </h3>
        <h4 id="제1조-목적">
          <a
            className="anchor"
            aria-hidden="true"
            tabIndex="-1"
            href="#제1조-목적"
          >
            <svg
              className="octicon octicon-link"
              viewBox="0 0 16 16"
              version="1.1"
              width="16"
              height="16"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M7.775 3.275a.75.75 0 001.06 1.06l1.25-1.25a2 2 0 112.83 2.83l-2.5 2.5a2 2 0 01-2.83 0 .75.75 0 00-1.06 1.06 3.5 3.5 0 004.95 0l2.5-2.5a3.5 3.5 0 00-4.95-4.95l-1.25 1.25zm-4.69 9.64a2 2 0 010-2.83l2.5-2.5a2 2 0 012.83 0 .75.75 0 001.06-1.06 3.5 3.5 0 00-4.95 0l-2.5 2.5a3.5 3.5 0 004.95 4.95l1.25-1.25a.75.75 0 00-1.06-1.06l-1.25 1.25a2 2 0 01-2.83 0z"
              ></path>
            </svg>
          </a>
          제1조 (목적)
        </h4>
        <ol>
          <li>
            플로웨이(이하 "회사"라 함)는 이용자의 개인정보보호를 매우
            중요시하며, 『개인정보보호법』,『정보통신망 이용촉진 및 정보보호에
            관한 법률』상의 개인정보보호규정 및 방송통신위원회가 제정한
            『개인정보보호지침』을 준수하고 있습니다. 회사는 개인정보처리방침을
            통하여 귀하께서 제공하시는 개인정보가 어떠한 용도와 방식으로
            이용되고 있으며, 개인정보보호를 위해 어떠한 조치가 취해지고 있는지
            알려드립니다.
          </li>
          <li>
            개인정보처리방침은 정부의 법령이나 지침의 변경, 또는 보다 나은
            서비스의 제공을 위하여 그 내용이 변경될 수 있습니다. 이 경우 회사는
            웹 사이트에서 공지사항에 이를 올리거나 이메일을 통해서 공지하고
            있습니다.
          </li>
          <li>
            회사는 개인정보처리방침을 사이트 첫 화면 또는 첫 화면과의 연결화면을
            통해 공개함으로써 이용자가 언제나 용이하게 보실 수 있도록 조치하고
            있습니다.
          </li>
          <li>
            회사는 개인정보처리방침의 지속적인 개선을 위하여 개인정보처리방침을
            개정하는데 필요한 절차를 정하고 있습니다.
          </li>
        </ol>
        <h4 id="제2조-개인정보-수집에-대한-동의-및-수집-방법">
          <a
            className="anchor"
            aria-hidden="true"
            tabIndex="-1"
            href="#제2조-개인정보-수집에-대한-동의-및-수집-방법"
          >
            <svg
              className="octicon octicon-link"
              viewBox="0 0 16 16"
              version="1.1"
              width="16"
              height="16"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M7.775 3.275a.75.75 0 001.06 1.06l1.25-1.25a2 2 0 112.83 2.83l-2.5 2.5a2 2 0 01-2.83 0 .75.75 0 00-1.06 1.06 3.5 3.5 0 004.95 0l2.5-2.5a3.5 3.5 0 00-4.95-4.95l-1.25 1.25zm-4.69 9.64a2 2 0 010-2.83l2.5-2.5a2 2 0 012.83 0 .75.75 0 001.06-1.06 3.5 3.5 0 00-4.95 0l-2.5 2.5a3.5 3.5 0 004.95 4.95l1.25-1.25a.75.75 0 00-1.06-1.06l-1.25 1.25a2 2 0 01-2.83 0z"
              ></path>
            </svg>
          </a>
          제2조 (개인정보 수집에 대한 동의 및 수집 방법)
        </h4>
        <ol>
          <li>
            서비스 이용과정에서 자동으로 수집되는 정보는 다음과 같습니다.
            <ul>
              <li>
                서비스 이용시간/이용기록, IP, 쿠키, 방문일시, 접속로그,
                이용콘텐츠, 기기모델명, 브라우저 정보
              </li>
            </ul>
          </li>
          <li>
            회사는 수집된 이용자들의 개인정보를 다음의 목적을 위해 이용하고
            있습니다.
            <ul>
              <li>
                회원관리 <br />
                회원제 서비스 이용에 따른 본인확인, 개인 식별, 불량회원의 부정
                이용 방지와 비인가 사용 방지, 가입 의사 확인, 가입 및 가입횟수
                제한, 분쟁 조정을 위한 기록 보존, 불만처리 등 민원처리, 고지사항
                전달
              </li>
              <li>
                서비스 제공에 관한 계약 이행 및 서비스 제공 <br />
                컨텐츠 및 회원 맞춤형 서비스 제공
              </li>
              <li>
                신규서비스 개발 / 마케팅 및 광고에 활용 <br />
                신규 서비스(컨텐츠) 개발 및 특화, 이벤트 등 광고성 정보 전달,
                통계학적 특성에 따른 서비스 제공 및 광고 게재, 접속 빈도 파악,
                회원의 서비스 이용에 대한 통계
              </li>
            </ul>
          </li>
          <li>
            회사는 다음과 같은 방법으로 개인정보를 수집할 수 있으며 개인식별이
            가능한 개인정보를 수집하는 경우에는 이용자로부터 동의를 받습니다.
            이용자가 회원가입 등의 페이지를 통해 동의 버튼을 클릭하거나,
            회원정보 수정 등을 통해 추가로 수집하는 개인정보를 기재한 후 저장할
            경우 개인정보 수집에 동의한 것으로 간주합니다.
            <ul>
              <li>홈페이지, 서면, 팩스, 전화, 고객센터 상담을 통한 수집</li>
              <li>생성정보 수집 툴을 통한 수집</li>
            </ul>
          </li>
        </ol>
        <h4 id="제3조-개인정보-수집--이용-목적-및-수집항목-등">
          <a
            className="anchor"
            aria-hidden="true"
            tabIndex="-1"
            href="#제3조-개인정보-수집--이용-목적-및-수집항목-등"
          >
            <svg
              className="octicon octicon-link"
              viewBox="0 0 16 16"
              version="1.1"
              width="16"
              height="16"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M7.775 3.275a.75.75 0 001.06 1.06l1.25-1.25a2 2 0 112.83 2.83l-2.5 2.5a2 2 0 01-2.83 0 .75.75 0 00-1.06 1.06 3.5 3.5 0 004.95 0l2.5-2.5a3.5 3.5 0 00-4.95-4.95l-1.25 1.25zm-4.69 9.64a2 2 0 010-2.83l2.5-2.5a2 2 0 012.83 0 .75.75 0 001.06-1.06 3.5 3.5 0 00-4.95 0l-2.5 2.5a3.5 3.5 0 004.95 4.95l1.25-1.25a.75.75 0 00-1.06-1.06l-1.25 1.25a2 2 0 01-2.83 0z"
              ></path>
            </svg>
          </a>
          제3조 (개인정보 수집 ・ 이용 목적 및 수집항목 등)
        </h4>
        <ol>
          <li>
            회사는 회원가입, 상담, 서비스 신청 및 제공 등을 위해 다음과 같은
            개인정보를 수집하고 있습니다. 이용자가 회원가입 등의 페이지를 통해
            동의 버튼을 클릭하거나, 회원정보 수정 등을 통해 추가로 수집하는
            개인정보를 기재한 후 저장할 경우 개인정보 수집에 동의한 것으로
            간주합니다. 회사의 각 서비스를 이용하시고자 할 경우 다음의
            필수정보를 입력해주셔야 하며 선택항목의 경우는 입력하시지 않았다하여
            서비스 이용에 제한은 없습니다. 단, 이용 목적에 따른 서비스 이용에는
            제한될 수 있습니다.
          </li>
          <li>이용자 개인정보 수집 항목</li>
        </ol>

        <table>
          <thead>
            <tr>
              <th style={{ textAlign: "center" }}>분류</th>
              <th style={{ textAlign: "center" }}>수집 ・ 이용 목적</th>
              <th style={{ textAlign: "left" }}>수집 ・ 이용 항목</th>
              <th style={{ textAlign: "center" }}>보유 ・ 이용 기간</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ textAlign: "center" }}>필수항목</td>
              <td style={{ textAlign: "center" }}>
                회원가입, 상담 및 부정이용 확인, 서비스 이용
              </td>
              <td style={{ textAlign: "left" }}>이메일</td>
              <td style={{ textAlign: "center" }}>
                계약 종료 시까지 또는 회원 탈퇴 시까지. 단, 관계법령에 의하여
                보존할 필요가 있는 경우를 제외하고 목적 달성 시 지체 없이 파기
              </td>
            </tr>
            <tr>
              <td style={{ textAlign: "center" }}>″</td>
              <td style={{ textAlign: "center" }}>
                간편로그인, 상담 및 부정이용 확인, 서비스 이용
              </td>
              <td style={{ textAlign: "left" }}>
                카카오 가입 시 : 카카오 계정 정보
              </td>
              <td style={{ textAlign: "center" }}>″</td>
            </tr>
            <tr>
              <td style={{ textAlign: "center" }}>선택항목</td>
              <td style={{ textAlign: "center" }}>사업자 인증, 서비스 이용</td>
              <td style={{ textAlign: "left" }}>사업자등록번호, 업종</td>
              <td style={{ textAlign: "center" }}>
                목적 달성 시 지체 없이 파기
              </td>
            </tr>
            <tr>
              <td style={{ textAlign: "center" }}>선택항목</td>
              <td style={{ textAlign: "center" }}>맞춤 서비스 제공</td>
              <td style={{ textAlign: "left" }}>
                성별, 닉네임, 연령대, 개업연월일, 사업장소재지
              </td>
              <td style={{ textAlign: "center" }}>
                계약 종료 시까지 또는 회원 탈퇴 시까지. 단, 관계법령에 의하여
                보존할 필요가 있는 경우를 제외하고 목적 달성 시 지체 없이 파기
              </td>
            </tr>
            <tr>
              <td style={{ textAlign: "center" }}>선택정보</td>
              <td style={{ textAlign: "center" }}>이벤트 / 마케팅</td>
              <td style={{ textAlign: "left" }}>
                경품제공에 필요한 정보, 이 외 마케팅 및 광고의 활용에 필요한
                이용자에 대한 정보
              </td>
              <td style={{ textAlign: "center" }}>
                계약 종료 시까지 또는회원탈퇴 시까지. 단, 관계법령에 의하여
                보존할 필요가 있는 경우를 제외하고 목적달성시 지체없이 파기
              </td>
            </tr>
          </tbody>
        </table>
        <ol start="3">
          <li>법령에 의해 수집 이용되는 회원 정보</li>
        </ol>

        <table>
          <thead>
            <tr>
              <th>보유 정보</th>
              <th style={{ textAlign: "center" }}>보유 기간</th>
              <th>근거 법령</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>계약 또는 청약철회 등에 관한 기록</td>
              <td style={{ textAlign: "center" }}>5년</td>
              <td>전자상거래 등에서의 소비자보호에 관한 법률</td>
            </tr>
            <tr>
              <td>대금결제 및 재화 등의 공급에 관한 기록</td>
              <td style={{ textAlign: "center" }}>5년</td>
              <td>전자상거래 등에서의 소비자보호에 관한 법률</td>
            </tr>
            <tr>
              <td>소비자의 불만 또는 분쟁처리에 관한 기록</td>
              <td style={{ textAlign: "center" }}>3년</td>
              <td>전자상거래 등에서의 소비자보호에 관한 법률</td>
            </tr>
            <tr>
              <td>표시, 광고에 관한 기록</td>
              <td style={{ textAlign: "center" }}>6개월</td>
              <td>전자상거래 등에서의 소비자보호에 관한 법률</td>
            </tr>
            <tr>
              <td>웹사이트 방문 기록</td>
              <td style={{ textAlign: "center" }}>3개월</td>
              <td>통신비밀보호법</td>
            </tr>
          </tbody>
        </table>
        <ol start="4">
          <li>
            <p>
              이용약관 및 관련 법령에 따라 보관 후 파기하는 이용자 개인정보 및
              아래 정보는 탈퇴일로부터 24시간 보관 후 파기합니다.
            </p>
            <ul>
              <li>
                탈퇴 후 24시간 내 재가입 방지를 위한 정보 (본인 인증 정보)
              </li>
              <li>
                부정거래 방지를 위한 정보 (고객번호(고유번호), Device ID,
                탈퇴일시)
              </li>
            </ul>
          </li>
          <li>
            <p>아래 정보는 해당 사유 종료시까지 보관 후 파기합니다.</p>
            <ul>
              <li>
                회사와 이용자간 민원, 소송 등 분쟁 과정 중 법률로 정한
                보유기간이 경과한 경우 분쟁 해결시까지 보관 후 파기
              </li>
              <li>
                회사가 개별적으로 이용자의 동의를 받은 경우 동의받은 기간까지
                보관 후 파기
              </li>
              <li>
                정산이 남아 있는 경우 예약 정보를 정산 완료된 후 법률로 정한
                보유기간 동안 보관 후 파기
              </li>
            </ul>
          </li>
          <li>
            <p>아래 정보는 해당 사유 종료시까지 보관 후 파기합니다.</p>
            <ul>
              <li>
                회사와 이용자간 민원, 소송 등 분쟁 과정 중 법률로 정한
                보유기간이 경과한 경우 분쟁 해결시까지 보관 후 파기
              </li>
              <li>
                회사가 개별적으로 이용자의 동의를 받은 경우 동의받은 기간까지
                보관 후 파기
              </li>
            </ul>
          </li>
          <li>
            <p>
              이용자의 기본적 인권 침해의 우려가 있는 민감한 개인정보(인종 및
              민족, 사상 및 신조, 출신지 및 본적지, 정치적 성향 및 범죄기록,
              의료정보 등)는 수집하지 않습니다.
            </p>
          </li>
          <li>
            <p>
              이용자의 개인정보는 서비스를 이용하는 시점부터 서비스를 제공하는
              기간 동안에만 제한적으로 이용하고 있습니다. 이용자가 회원탈퇴를
              요청하거나 이용자의 마지막 로그인 일시를 기준으로 1년이 초과되어
              이용자의 계정이 탈퇴 처리되는 경우, 제공한 개인정보의 수집 및
              이용에 대한 동의를 철회하는 경우, 또는 수집 및 이용목적이
              달성되거나 보유 및 이용기간이 종료한 경우 해당 이용자의 개인정보는
              지체 없이 파기 됩니다.
            </p>
            <ul>
              <li>종이에 출력된 개인 정보 : 분쇄기로 분쇄하거나 소각</li>
              <li>
                전자적 파일 형태로 저장된 개인 정보 : 기록을 재사용할 수 없는
                기술적 방법을 사용하여 삭제
              </li>
            </ul>
          </li>
          <li>
            <p>
              이용자의 동의를 받아 보유하고 있는 거래정보 등을 이용자께서 열람을
              요구하시는 경우 회사는 지체 없이 그 내역을 확인 할 수 있도록
              조치합니다.
            </p>
          </li>
          <li>
            <p>
              회사가 서비스 제공을 위해 수집한 이용자의 모든 개인정보는 수집
              단계부터 안전한 암호화 통신을 이용하여, AWS(Amazon Web Services)
              상의 대한민국 리전에 위치한 데이타센터로 전송되며,
              개인정보처리방침의 보관기간 동안 저장합니다. 클라우드의 보안은
              AWS가 취득한 국제 인증 프로그램을 통해서 확인 할 수 있으며, 회사와
              클라우드 제공사인 AWS의 공동 책임 문서는 이 링크에서 확인할 수
              있습니다.(
              <a href="https://aws.amazon.com/ko/compliance/shared-responsibility-model/">
                https://aws.amazon.com/ko/compliance/shared-responsibility-model/
              </a>
              )
            </p>
          </li>
        </ol>
        <h4 id="제4조-개인정보-자동수집-장치의-설치--운영-및-그-거부에-관한-사항">
          <a
            className="anchor"
            aria-hidden="true"
            tabIndex="-1"
            href="#제4조-개인정보-자동수집-장치의-설치--운영-및-그-거부에-관한-사항"
          >
            <svg
              className="octicon octicon-link"
              viewBox="0 0 16 16"
              version="1.1"
              width="16"
              height="16"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M7.775 3.275a.75.75 0 001.06 1.06l1.25-1.25a2 2 0 112.83 2.83l-2.5 2.5a2 2 0 01-2.83 0 .75.75 0 00-1.06 1.06 3.5 3.5 0 004.95 0l2.5-2.5a3.5 3.5 0 00-4.95-4.95l-1.25 1.25zm-4.69 9.64a2 2 0 010-2.83l2.5-2.5a2 2 0 012.83 0 .75.75 0 001.06-1.06 3.5 3.5 0 00-4.95 0l-2.5 2.5a3.5 3.5 0 004.95 4.95l1.25-1.25a.75.75 0 00-1.06-1.06l-1.25 1.25a2 2 0 01-2.83 0z"
              ></path>
            </svg>
          </a>
          제4조 (개인정보 자동수집 장치의 설치 ・ 운영 및 그 거부에 관한 사항)
        </h4>
        <ol>
          <li>
            <p>
              쿠키(cookie)는 웹사이트가 이용자의 브라우저(인터넷 익스플로러,
              크롬, 파이어폭스, 기타 모바일 브라우저)로 전송하는 소량의
              정보입니다. 회사는 이용자에 대한 정보를 저장하고 수시로 찾아내는
              ‘쿠키(cookie)’를 사용합니다. 쿠키는 이용자의 컴퓨터 또는 모바일
              기기는 식별하지만 이용자을 개인적으로 식별하지는 않습니다. 또한
              회원은 쿠키에 대한 선택권이 있습니다.
            </p>
            <ul>
              <li>
                웹브라우저 상단의 도구 &gt; 인터넷옵션 탭(option tab)에서 모든
                쿠키를 다 받아들이거나, 쿠키가 설치될 때 통지를 보내도록 하거나,
                아니면 모든 쿠키를 거부할 수 있는 선택권을 가질 수 있습니다.
              </li>
              <li>
                모바일 기기의 경우에도 ‘설정’ 메뉴나 또는 각 모바일 브라우저의
                설정 메뉴에서 쿠키에 대한 선택을 제어할 수 있습니다. 다만,
                쿠키를 거부할 경우 로그인이 필요한 서비스 이용에 일부 제약이
                있을 수 있습니다.
              </li>
            </ul>
          </li>
          <li>
            <p>회사의 쿠키(cookie) 운용</p>
            <ul>
              <li>운영 및 관리하는 숙소 정보의 인가</li>
              <li>
                로그인 유지 기간 관리 등 서비스의 보안 및 편의를 위한 정책의
                적용
              </li>
              <li>유료서비스 이용 시 이용기간 안내</li>
              <li>개인의 관심 분야에 따라 차별화된 정보를 제공</li>
              <li>
                회원과 비회원의 접속빈도 또는 머문 시간 등을 분석하여 이용자의
                취향과 관심분야를 파악하여 타겟(target) 마케팅에 활용
              </li>
              <li>
                클릭한 정보들에 대한 세부정보와 관심 있게 둘러본 정보들에 대한
                자취를 분석하여 다음 번 접속 때 개인 맞춤 서비스를 제공
              </li>
              <li>회원들의 습관을 분석하여 서비스 개편 등의 척도로 이용</li>
            </ul>
          </li>
        </ol>
        <h4 id="제5조-개인정보의-위탁처리">
          <a
            className="anchor"
            aria-hidden="true"
            tabIndex="-1"
            href="#제5조-개인정보의-위탁처리"
          >
            <svg
              className="octicon octicon-link"
              viewBox="0 0 16 16"
              version="1.1"
              width="16"
              height="16"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M7.775 3.275a.75.75 0 001.06 1.06l1.25-1.25a2 2 0 112.83 2.83l-2.5 2.5a2 2 0 01-2.83 0 .75.75 0 00-1.06 1.06 3.5 3.5 0 004.95 0l2.5-2.5a3.5 3.5 0 00-4.95-4.95l-1.25 1.25zm-4.69 9.64a2 2 0 010-2.83l2.5-2.5a2 2 0 012.83 0 .75.75 0 001.06-1.06 3.5 3.5 0 00-4.95 0l-2.5 2.5a3.5 3.5 0 004.95 4.95l1.25-1.25a.75.75 0 00-1.06-1.06l-1.25 1.25a2 2 0 01-2.83 0z"
              ></path>
            </svg>
          </a>
          제5조 (개인정보의 위탁처리)
        </h4>
        <p>
          회사는 서비스 향상을 위해서 회원의 개인정보가 필요한 경우 동의 등
          법률상의 요건을 구비하여 아래와 같이 개인정보의 처리를 위탁하고
          있으며, 관계 법령에 따라 위탁계약 시 개인정보가 안전하게 관리될 수
          있도록 필요한 사항을 규정하고 있습니다. 이 때에 공유하는 정보는 당해
          목적을 달성하기 위하여 필요한 최소한의 정보에 국한됩니다.
        </p>

        <table>
          <thead>
            <tr>
              <th>수탁업체</th>
              <th>위탁 업무 내용</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>(주)카카오</td>
              <td>서비스 안내 및 고객 CS</td>
            </tr>
            <tr>
              <td>Amazon Web Services Inc.</td>
              <td>
                데이터 보관 및 처리, 이메일, 문서/파일 저장과 내부 커뮤니케이션
                및 협업 도구
              </td>
            </tr>
          </tbody>
        </table>
        <h4 id="제6조-개인정보의-열람-정정">
          <a
            className="anchor"
            aria-hidden="true"
            tabIndex="-1"
            href="#제6조-개인정보의-열람-정정"
          >
            <svg
              className="octicon octicon-link"
              viewBox="0 0 16 16"
              version="1.1"
              width="16"
              height="16"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M7.775 3.275a.75.75 0 001.06 1.06l1.25-1.25a2 2 0 112.83 2.83l-2.5 2.5a2 2 0 01-2.83 0 .75.75 0 00-1.06 1.06 3.5 3.5 0 004.95 0l2.5-2.5a3.5 3.5 0 00-4.95-4.95l-1.25 1.25zm-4.69 9.64a2 2 0 010-2.83l2.5-2.5a2 2 0 012.83 0 .75.75 0 001.06-1.06 3.5 3.5 0 00-4.95 0l-2.5 2.5a3.5 3.5 0 004.95 4.95l1.25-1.25a.75.75 0 00-1.06-1.06l-1.25 1.25a2 2 0 01-2.83 0z"
              ></path>
            </svg>
          </a>
          제6조 (개인정보의 열람, 정정)
        </h4>
        <ol>
          <li>
            이용자는 등록되어 있는 본인의 개인정보를 열람하거나 정정하실 수
            있습니다. 개인정보 열람 및 정정을 하고자 할 경우에는 직접 수정 또는
            개인정보보호책임자 및 담당자에게 서면, 전화 또는 E-mail로 연락하시면
            지체 없이 조치하겠습니다.
          </li>
          <li>
            잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를
            제3자에게 지체 없이 통지하여 정정하도록 조치하겠습니다.
          </li>
        </ol>
        <h4 id="제7조-동의-철회">
          <a
            className="anchor"
            aria-hidden="true"
            tabIndex="-1"
            href="#제7조-동의-철회"
          >
            <svg
              className="octicon octicon-link"
              viewBox="0 0 16 16"
              version="1.1"
              width="16"
              height="16"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M7.775 3.275a.75.75 0 001.06 1.06l1.25-1.25a2 2 0 112.83 2.83l-2.5 2.5a2 2 0 01-2.83 0 .75.75 0 00-1.06 1.06 3.5 3.5 0 004.95 0l2.5-2.5a3.5 3.5 0 00-4.95-4.95l-1.25 1.25zm-4.69 9.64a2 2 0 010-2.83l2.5-2.5a2 2 0 012.83 0 .75.75 0 001.06-1.06 3.5 3.5 0 00-4.95 0l-2.5 2.5a3.5 3.5 0 004.95 4.95l1.25-1.25a.75.75 0 00-1.06-1.06l-1.25 1.25a2 2 0 01-2.83 0z"
              ></path>
            </svg>
          </a>
          제8조 (동의 철회)
        </h4>
        <ol>
          <li>
            회원가입 등을 통해 개인정보의 수집, 이용, 제공에 대해 회원이 동의한
            내용을 회원은 언제든지 철회하실 수 있습니다. 개인정보보호책임자 또는
            담당자에게 우편, 고객센터, 전화 등으로 회원탈퇴 의사를 전달하시면
            개인정보의 삭제 등 필요한 조치를 하겠습니다. 동의 철회를 하고
            개인정보를 파기하는 등의 조치를 취한 경우에는 그 사실을 귀하께 지체
            없이 통지하도록 하겠습니다.
          </li>
          <li>
            회사는 개인정보의 수집에 대한 동의철회(회원탈퇴)를 개인정보를
            수집하는 방법보다 쉽게 할 수 있도록 필요한 조치를 취하겠습니다.
          </li>
        </ol>
        <h4 id="제8조-개인정보보호를-위한-기술-및-관리적-대책">
          <a
            className="anchor"
            aria-hidden="true"
            tabIndex="-1"
            href="#제8조-개인정보보호를-위한-기술-및-관리적-대책"
          >
            <svg
              className="octicon octicon-link"
              viewBox="0 0 16 16"
              version="1.1"
              width="16"
              height="16"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M7.775 3.275a.75.75 0 001.06 1.06l1.25-1.25a2 2 0 112.83 2.83l-2.5 2.5a2 2 0 01-2.83 0 .75.75 0 00-1.06 1.06 3.5 3.5 0 004.95 0l2.5-2.5a3.5 3.5 0 00-4.95-4.95l-1.25 1.25zm-4.69 9.64a2 2 0 010-2.83l2.5-2.5a2 2 0 012.83 0 .75.75 0 001.06-1.06 3.5 3.5 0 00-4.95 0l-2.5 2.5a3.5 3.5 0 004.95 4.95l1.25-1.25a.75.75 0 00-1.06-1.06l-1.25 1.25a2 2 0 01-2.83 0z"
              ></path>
            </svg>
          </a>
          제8조 (개인정보보호를 위한 기술 및 관리적 대책)
        </h4>
        <p>
          회사는 이용자들의 개인정보를 보호하기 위하여 다음과 같은 보호 대책을
          시행하고 있습니다.
        </p>
        <ol>
          <li>
            기술적 대책
            <ul>
              <li>
                이용자의 개인정보는 비밀번호에 의해 보호되며 파일 및
                전송데이터를 암호화하고 중요한 데이터는 별도의 보안기능을 통해
                보호되고 있습니다.
              </li>
              <li>
                회사는 백신프로그램을 이용하여 컴퓨터바이러스에 의한 피해를
                방지하기 위한 조치를 취하고 있습니다. 백신프로그램은 주기적으로
                업데이트되며 갑작스런 바이러스가 출현할 경우 백신이 나오는 즉시
                이를 제공함으로써 개인정보가 침해되는 것을 방지하고 있습니다.
              </li>
              <li>
                해킹 등 외부침입에 대비하여 각 서버마다 침입차단시스템 및 취약점
                분석시스템 등을 이용하여 보안에 만전을 기하고 있습니다.
              </li>
            </ul>
          </li>
          <li>
            관리적 대책
            <ul>
              <li>
                회사는 회사의 개인정보 취급자를 최소한으로 제한하며, 개인정보
                취급자에 대한 교육 등 관리적 조치를 통해 개인정보보호의 중요성을
                인식시키고 있습니다.
              </li>
              <li>
                회사는 개인정보처리방침의 이행사항 및 담당자의 준수여부를
                확인하여 문제가 발견될 경우 즉시 수정하고 바로 잡을 수 있도록
                노력하고 있습니다. 단, 회사가 개인정보보호 의무를 다 하였음에도
                불구하고 이용자 본인의 부주의나 회사가 관리하지 않는 영역에서의
                사고 등 회사의 귀책에 기인하지 않은 손해에 대해서는 회사는
                책임을 지지 않습니다.
              </li>
              <li>
                그 외 내부 관리자의 실수나 기술관리 상의 사고로 인해 개인정보의
                상실, 유출, 변조, 훼손이 유발될 경우 회사는 즉각 이용자께 사실을
                알리고 적절한 대책과 보상을 강구할 것입니다.
              </li>
            </ul>
          </li>
        </ol>
        <h4 id="제9조-이용자의-권리와-의무">
          <a
            className="anchor"
            aria-hidden="true"
            tabIndex="-1"
            href="#제9조-이용자의-권리와-의무"
          >
            <svg
              className="octicon octicon-link"
              viewBox="0 0 16 16"
              version="1.1"
              width="16"
              height="16"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M7.775 3.275a.75.75 0 001.06 1.06l1.25-1.25a2 2 0 112.83 2.83l-2.5 2.5a2 2 0 01-2.83 0 .75.75 0 00-1.06 1.06 3.5 3.5 0 004.95 0l2.5-2.5a3.5 3.5 0 00-4.95-4.95l-1.25 1.25zm-4.69 9.64a2 2 0 010-2.83l2.5-2.5a2 2 0 012.83 0 .75.75 0 001.06-1.06 3.5 3.5 0 00-4.95 0l-2.5 2.5a3.5 3.5 0 004.95 4.95l1.25-1.25a.75.75 0 00-1.06-1.06l-1.25 1.25a2 2 0 01-2.83 0z"
              ></path>
            </svg>
          </a>
          제9조 (이용자의 권리와 의무)
        </h4>
        <p>
          이용자의 개인정보를 최신의 상태로 정확하게 입력하여 불의의 사고를
          예방해 주시기 바랍니다. 이용자가 입력한 부정확한 정보로 인해 발생하는
          사고의 책임은 이용자 자신에게 있으며 타인 정보의 도용 등 허위정보를
          입력할 경우 회원자격이 상실될 수 있습니다. 이에 해당하는 내용은 아래와
          같습니다.
        </p>
        <ol>
          <li>
            이용자는 자신의 개인정보를 최신의 상태로 유지해야 하며, 이용자의
            부정확한 정보 입력으로 발생하는 문제의 책임은 이용자 자신에게
            있습니다.
          </li>
          <li>
            타인의 주민번호 등 개인정보를 도용하여 회원가입 또는 사이트 이용 시
            회원자격 상실과 함께 주민등록법에 의거하여 처벌될 수 있습니다.
          </li>
          <li>
            이용자는 아이디, 비밀번호 등에 대해 보안을 유지할 책임이 있으며
            제3자에게 이를 양도하거나 대여할 수 없습니다.
          </li>
          <li>
            비밀번호를 포함한 귀하의 개인정보가 유출되지 않도록 조심하시고
            게시물을 포함한 타인의 개인정보를 훼손하지 않도록 유의해 주십시오.
            만약 이 같은 책임을 다하지 못하고 타인의 정보 및 존엄성을 훼손할
            시에는 『정보통신망이용촉진 및 정보보호 등에 관한 법률』,
            『개인정보보호법』 등에 의해 처벌받을 수 있습니다.
          </li>
        </ol>
        <h4 id="제10조-의견수렴-및-불만처리">
          <a
            className="anchor"
            aria-hidden="true"
            tabIndex="-1"
            href="#제10조-의견수렴-및-불만처리"
          >
            <svg
              className="octicon octicon-link"
              viewBox="0 0 16 16"
              version="1.1"
              width="16"
              height="16"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M7.775 3.275a.75.75 0 001.06 1.06l1.25-1.25a2 2 0 112.83 2.83l-2.5 2.5a2 2 0 01-2.83 0 .75.75 0 00-1.06 1.06 3.5 3.5 0 004.95 0l2.5-2.5a3.5 3.5 0 00-4.95-4.95l-1.25 1.25zm-4.69 9.64a2 2 0 010-2.83l2.5-2.5a2 2 0 012.83 0 .75.75 0 001.06-1.06 3.5 3.5 0 00-4.95 0l-2.5 2.5a3.5 3.5 0 004.95 4.95l1.25-1.25a.75.75 0 00-1.06-1.06l-1.25 1.25a2 2 0 01-2.83 0z"
              ></path>
            </svg>
          </a>
          제10조 (의견수렴 및 불만처리)
        </h4>
        <ol>
          <li>
            <p>
              회사는 이용자의 의견을 소중하게 생각하며, 이용자은
              의문사항으로부터 언제나 성실한 답변을 받을 권리가 있습니다.
            </p>
          </li>
          <li>
            <p>
              회사는 이용자와의 원활한 의사소통을 위해 고객센터를 운영하고
              있으며 연락처는 아래와 같습니다.
            </p>
            <ul>
              <li>
                [고객센터]
                <ul>
                  <li>카카오채널 : 플로웨이(floway)</li>
                  <li>
                    전자우편 :
                    <a href="mailto:floway.official@gmail.com">
                      floway.official@gmail.com
                    </a>
                  </li>
                  <li>전화번호 : 010-9945-7238</li>
                  <li>주소 : 서울시 광진구 아차산로21길 98-6</li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <p>
              기타 개인정보에 관한 상담이 필요한 경우에는 회사의 위 전자우편으로
              문의하실 수 있으며, 국가기관에 신고나 상담이 필요한 경우에는
              아래의 연락처에 문의하셔서 도움을 받으실 수 있습니다.
            </p>
            <ul>
              <li>
                개인정보침해신고센터 <br />(
                <a href="http://privacy.kisa.or.kr">
                  http://privacy.kisa.or.kr
                </a>
                / 국번 없이 118)
              </li>
              <li>
                대검찰청 사이버수사과 <br />(
                <a href="http://spo.go.kr">http://spo.go.kr</a>/ 국번 없이 1301)
              </li>
              <li>
                경찰청 사이버안전지킴이 <br />(
                <a href="http://www.police.go.kr">http://www.police.go.kr</a>/
                국번 없이 182)
              </li>
              <li>
                개인정보 분쟁조정위원회 <br />(
                <a href="http://www.kopico.go.kr">www.kopico.go.kr</a>/
                1833-6972)
              </li>
            </ul>
          </li>
        </ol>
        <h4 id="제11조-개인정보-보호책임자">
          <a
            className="anchor"
            aria-hidden="true"
            tabIndex="-1"
            href="#제11조-개인정보-보호책임자"
          >
            <svg
              className="octicon octicon-link"
              viewBox="0 0 16 16"
              version="1.1"
              width="16"
              height="16"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M7.775 3.275a.75.75 0 001.06 1.06l1.25-1.25a2 2 0 112.83 2.83l-2.5 2.5a2 2 0 01-2.83 0 .75.75 0 00-1.06 1.06 3.5 3.5 0 004.95 0l2.5-2.5a3.5 3.5 0 00-4.95-4.95l-1.25 1.25zm-4.69 9.64a2 2 0 010-2.83l2.5-2.5a2 2 0 012.83 0 .75.75 0 001.06-1.06 3.5 3.5 0 00-4.95 0l-2.5 2.5a3.5 3.5 0 004.95 4.95l1.25-1.25a.75.75 0 00-1.06-1.06l-1.25 1.25a2 2 0 01-2.83 0z"
              ></path>
            </svg>
          </a>
          제11조 (개인정보 보호책임자)
        </h4>
        <p>
          회사는 이용자께서 좋은 정보를 안전하게 이용할 수 있도록 최선을 다하고
          있습니다. <br />
          그러나 기술적인 보완조치를 했음에도 불구하고, 해킹 등 기본적인
          네트워크상의 위험성에 의해 발생하는 예기치 못한 사고로 인한 정보의
          훼손 및 방문자가 작성한 게시물에 의한 각종 분쟁에 관해서는 책임이
          없습니다. 회사는 회원의 개인정보를 보호하고 개인정보와 관련한 불만을
          처리하기 위하여 아래와 같이 관련 부서 및 개인정보 보호책임자를
          지정하고 있습니다.
        </p>

        <table>
          <thead>
            <tr>
              <th>구분</th>
              <th>개인정보 보호책임자</th>
              <th>개인정보 관리담당자</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>성명</td>
              <td>안중석 / 대표</td>
            </tr>
            <tr>
              <td>연락처</td>
              <td>010-9945-7238</td>
            </tr>
            <tr>
              <td>전자우편</td>
              <td>
                <a href="mailto:floway.official@gmail.com">
                  floway.official@gmail.com
                </a>
              </td>
            </tr>
          </tbody>
        </table>
        <h4 id="제12조-개인정보-처리방침의-개정과-그-공지">
          <a
            className="anchor"
            aria-hidden="true"
            tabIndex="-1"
            href="#제12조-개인정보-처리방침의-개정과-그-공지"
          >
            <svg
              className="octicon octicon-link"
              viewBox="0 0 16 16"
              version="1.1"
              width="16"
              height="16"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M7.775 3.275a.75.75 0 001.06 1.06l1.25-1.25a2 2 0 112.83 2.83l-2.5 2.5a2 2 0 01-2.83 0 .75.75 0 00-1.06 1.06 3.5 3.5 0 004.95 0l2.5-2.5a3.5 3.5 0 00-4.95-4.95l-1.25 1.25zm-4.69 9.64a2 2 0 010-2.83l2.5-2.5a2 2 0 012.83 0 .75.75 0 001.06-1.06 3.5 3.5 0 00-4.95 0l-2.5 2.5a3.5 3.5 0 004.95 4.95l1.25-1.25a.75.75 0 00-1.06-1.06l-1.25 1.25a2 2 0 01-2.83 0z"
              ></path>
            </svg>
          </a>
          제13조 (개인정보 처리방침의 개정과 그 공지)
        </h4>
        <p>
          법령, 정책 또는 보안기술의 변경에 따라 내용의 추가, 삭제 및 수정이
          있을 시에는 이용자가 언제든지 변경된 사항을 쉽게 알아볼 수 있도록
          변경사항 시행일의 7일 전부터 홈페이지의 '공지사항'란 또는 별도의 창을
          통해 고지할 것입니다. 다만, 개인정보의 수집 및 활용, 제3자 제공 등과
          같이 이용자 권리의 중요한 변경이 있을 경우에는 최소 30일 전에
          고지합니다
        </p>
        <h4 id="부-칙">
          <a className="anchor" aria-hidden="true" tabIndex="-1" href="#부-칙">
            <svg
              className="octicon octicon-link"
              viewBox="0 0 16 16"
              version="1.1"
              width="16"
              height="16"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M7.775 3.275a.75.75 0 001.06 1.06l1.25-1.25a2 2 0 112.83 2.83l-2.5 2.5a2 2 0 01-2.83 0 .75.75 0 00-1.06 1.06 3.5 3.5 0 004.95 0l2.5-2.5a3.5 3.5 0 00-4.95-4.95l-1.25 1.25zm-4.69 9.64a2 2 0 010-2.83l2.5-2.5a2 2 0 012.83 0 .75.75 0 001.06-1.06 3.5 3.5 0 00-4.95 0l-2.5 2.5a3.5 3.5 0 004.95 4.95l1.25-1.25a.75.75 0 00-1.06-1.06l-1.25 1.25a2 2 0 01-2.83 0z"
              ></path>
            </svg>
          </a>
          부 칙
        </h4>
        <p>제1조(시행일) 본 약관은 2022년 8월 29일부터 시행합니다</p>
      </div>
    </Fragment>
  );
};

export default PrivacyPolicy;
